export const GET_SCHEDULE_PERIODS = 'GET_SCHEDULE_PERIODS'; 
export const GET_SCHOOL_TIMETABLE = 'GET_SCHOOL_TIMETABLE'; 
export const GET_DAYS_OF_WEEKS = 'GET_DAYS_OF_WEEKS'; 
export const GET_CLASS_SCHEDULE = 'GET_CLASS_SCHEDULE'; 
export const GET_TEACHER_SCHEDULE = 'GET_TEACHER_SCHEDULE';